// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionHeader_root__1ahiv","title":"SectionHeader_title__2H4WF","subTitle":"SectionHeader_subTitle__2fAiV"};